/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardCategory_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl + 'rest/loyaltyCardCategories/:id',{}, {
            query: { method: 'GET', isArray: false },
            getTree: { method: 'GET', isArray: false , url:baseUrl+'rest/loyaltyCardCategories/tree'},
            getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/loyaltyCardCategories/deleted'},
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardCategory',["LoyaltyCardCategory_Resource","LoyaltyCard","LoyaltyCardCategoryData","LoyaltyCardData","ImageData","CompanyImageData",
        function (LoyaltyCardCategory_Resource,LoyaltyCard,LoyaltyCardCategoryData,LoyaltyCardData,ImageData,CompanyImageData)
    {
        var LoyaltyCardCategory = function (rsLoyaltyCardCategory,parentCategory)
        {
            this.id = null;
            this.isDeleted;
            this.label = "";
            this.description = "";
            this.image = null;
            this.companyImage = null;
            this.specificImage;//boolean
            this.isVisibleOnWebSite;
            this.style = "";
            this.loyaltyCards = [];
            this.categories = [];
            this.parentCategoryId = null;
            this.version = null;

            if (parentCategory!==undefined && parentCategory!=null)
                this.parentCategory=  parentCategory;

            if (rsLoyaltyCardCategory!==undefined && rsLoyaltyCardCategory!=null)
            {
                var loyaltyCard,category;
                if (!this.id)
                    this.id = rsLoyaltyCardCategory.id;
                this.isDeleted = rsLoyaltyCardCategory.isDeleted;
                this.label = rsLoyaltyCardCategory.label;
                this.description = rsLoyaltyCardCategory.description;
                this.imageId =  rsLoyaltyCardCategory.imageId;
                this.companyImageId =  rsLoyaltyCardCategory.companyImageId;
                this.specificImage = rsLoyaltyCardCategory.specificImage;
                this.isVisibleOnWebSite = rsLoyaltyCardCategory.isVisibleOnWebSite;
                this.parentCategoryId =  rsLoyaltyCardCategory.parentCategoryId;
                this.style = rsLoyaltyCardCategory.style;

                if ( rsLoyaltyCardCategory.categories)
                    for (var i=0;i< rsLoyaltyCardCategory.categories.length;i++)
                    {
                        category = new LoyaltyCardCategory(rsLoyaltyCardCategory.categories[i],this);
                        this.categories.push(category);
                    }

                if ( rsLoyaltyCardCategory.loyaltyCards)
                    for (var j=0;j< rsLoyaltyCardCategory.loyaltyCards.length;j++)
                    {
                        loyaltyCard = new LoyaltyCard(rsLoyaltyCardCategory.loyaltyCards[j],this);
                        this.loyaltyCards.push(loyaltyCard);
                    }
            }
            LoyaltyCardCategoryData.add(this);
        }

        LoyaltyCardCategory.prototype.loadObject = function(object,parentCategory)
        {
            this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.description = object.description;
            this.style= object.style;
            this.specificImage = object.specificImage;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;

            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory=  parentCategory;
            }

            //load ref from ids
            if (object.loyaltyCardsId)
            {
                var newLoyaltyCards = [];
                for (var i=0;i<object.loyaltyCardsId.length;i++)
                {
                    var loyaltyCard =  LoyaltyCardData.getById(object.loyaltyCardsId[i]);
                    if (loyaltyCard!=null)
                        newLoyaltyCards.push(loyaltyCard);
                }
                this.loyaltyCards = newLoyaltyCards;
            }
            if (object.loyaltyCardsId)
            {
                var newCategories = [];
                for (i=0;i<object.categoriesId.length;i++)
                {
                    var category =  LoyaltyCardCategoryData.getById(object.categoriesId[i]);
                    if (category!=null)
                        newCategories.push(category);
                }
                this.categories = newCategories;
            }


        }
        LoyaltyCardCategory.prototype.getObjectResource = function()
        {
            var rsLoyaltyCardCategory = new LoyaltyCardCategory_Resource();
            rsLoyaltyCardCategory.id = this.id ;
            rsLoyaltyCardCategory.isDeleted = this.isDeleted;
            rsLoyaltyCardCategory.label =this.label;
            rsLoyaltyCardCategory.description =this.description;
            if (this.image)
                rsLoyaltyCardCategory.imageId = this.image.id;
            if (this.companyImage)
                rsLoyaltyCardCategory.companyImageId = this.companyImage.id;
            rsLoyaltyCardCategory.specificImage = this.specificImage;
            rsLoyaltyCardCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsLoyaltyCardCategory.style = this.style;

            if (this.parentCategory)
                rsLoyaltyCardCategory.parentCategoryId = this.parentCategory.getId();
            rsLoyaltyCardCategory.categoriesId = [];
            for (var i=0;i< this.categories.length;i++)
                rsLoyaltyCardCategory.categoriesId.push( this.categories[i].getId());
            rsLoyaltyCardCategory.loyaltyCardsId = [];
            for (var i=0;i< this.loyaltyCards.length;i++)
                rsLoyaltyCardCategory.loyaltyCardsId.push(this.loyaltyCards[i].getId());
            return rsLoyaltyCardCategory;
        }
        LoyaltyCardCategory.prototype.getId = function()
        {
            return this.id;
        }
        LoyaltyCardCategory.prototype.setId = function(id)
        {
            this.id = id;
        }
        LoyaltyCardCategory.prototype.getLabel = function()
        {
            return this.label;
        }
        LoyaltyCardCategory.prototype.addLoyaltyCard = function(loyaltyCard)
        {
            var index = this.loyaltyCards.indexOf(loyaltyCard);
            if (index==-1)//Not already there
            {
                this.loyaltyCards.push(loyaltyCard);
                loyaltyCard.parentCategory = this;
            }
        }
        LoyaltyCardCategory.prototype.removeLoyaltyCard = function(loyaltyCard)
        {
            var index = this.loyaltyCards.indexOf(loyaltyCard);
            if (index!=-1)//Found
            {
                this.loyaltyCards.splice(index,1);
            }

        }
        LoyaltyCardCategory.prototype.addCategory = function(category)
        {
            if (category) {
                var index = this.categories.indexOf(category);
                if (index == -1)//Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
            }
        }
        LoyaltyCardCategory.prototype.removeCategory = function(category)
        {
            var index = this.categories.indexOf(category);
            if (index!=-1)//Found
            {
                this.categories.splice(index,1);
            }

        }        
        LoyaltyCardCategory.prototype.changeLoyaltyCardPosition = function(loyaltyCard,indexTarget)
        {
            //Change the loyaltyCard position
            var index = this.loyaltyCards.indexOf(loyaltyCard);
            if (indexTarget!=-1 && index!=-1 && indexTarget!=index && this.loyaltyCards && indexTarget<this.loyaltyCards.length)
            {
                var cat = this.loyaltyCards[indexTarget];

                this.loyaltyCards.splice(index,1);
                if (index<indexTarget)
                    indexTarget--;
                this.loyaltyCards.splice(indexTarget,0,loyaltyCard);

            }

        };
        LoyaltyCardCategory.prototype.getLoyaltyCardById =  function(loyaltyCardId)
        {
            //recursive research
            var loyaltyCard = null;
            for (var j = 0; j < this.loyaltyCards.length; j++)
                if (this.loyaltyCards[j].id == loyaltyCardId)
                    return this.loyaltyCards[j];
            for (var z=0;z< this.categories.length && !loyaltyCard;z++)
                loyaltyCard = this.categories[z].getLoyaltyCardById(loyaltyCardId);

            return loyaltyCard;
        };
        LoyaltyCardCategory.prototype.getLoyaltyCardByLabel =  function(loyaltyCardLabel)
        {
            //recursive research, need lower case input
            var loyaltyCard = null;
            for (var j = 0; j < this.loyaltyCards.length; j++)
                if (this.loyaltyCards[j].label.toLowerCase() == loyaltyCardLabel)
                    return this.loyaltyCards[j];
            for (var z=0;z< this.categories.length && !loyaltyCard;z++)
                loyaltyCard = this.categories[z].getLoyaltyCardByLabel(loyaltyCardLabel);

            return loyaltyCard;
        };
        LoyaltyCardCategory.prototype.getLoyaltyCardCategoryById =  function(categoryId)
        {
            //recursive research
            var category = null;
            for (var z=0;z< this.categories.length && !category;z++)
                if (this.categories[z].id == categoryId)
                    category= this.categories[z];
                else
                    category = this.categories[z].getLoyaltyCardCategoryById(categoryId);
            return category;
        };
        LoyaltyCardCategory.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = LoyaltyCardCategoryData.getById(this.parentCategoryId);
        };

        LoyaltyCardCategory.prototype.getSubStatCategories =  function(rootCategory)
        {
            return this.categories.concat(this.loyaltyCards);
        }

        LoyaltyCardCategory.prototype.isDescendantOf = function(category) {
            var isDescendantOf = false;
            if(this.parentCategory === category) {
                isDescendantOf = true;
            }
            else {
                if(this.parentCategory) {
                    isDescendantOf = this.parentCategory.isDescendantOf(category);
                }
            }

            return isDescendantOf;
        }

        return LoyaltyCardCategory;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardCategorySrv',["LoyaltyCardCategory_Resource","LoyaltyCardCategory","LoyaltyCardCategoryData","UserActionData","LoyaltyCardSrv","$log","ServerSrv",
        function (LoyaltyCardCategory_Resource,LoyaltyCardCategory,LoyaltyCardCategoryData,UserActionData,LoyaltyCardSrv,$log,ServerSrv)
    {
        //$timeout (function () {

        var  categorySrv = {};
        categorySrv.query = function(successFunction,errorFunction)
        {
            var treeLoaded = false;
            var deletedLoaded = false;
            LoyaltyCardCategory_Resource.getTree(
                {}, //params
                function (data) {   //success
                    LoyaltyCardCategoryData.categoryRoot = new LoyaltyCardCategory(data);
                    if (successFunction !== undefined && deletedLoaded)
                        successFunction(LoyaltyCardCategoryData.categoryRoot);
                    treeLoaded = true;
                },
                function (data) {   //failure
                    $log.error("LoyaltyCardCategory_Resource.getTree error");
                    $log.error(data);
                    if (errorFunction!== undefined && deletedLoaded)
                        errorFunction(data);
                    treeLoaded = true;
                });
            LoyaltyCardCategory_Resource.getDeleted(
                {}, //params
                function (data) {   //success
                    LoyaltyCardCategoryData.deletedCategories = [] ;
                    for (var i=0;i< data.length;i++)
                        new LoyaltyCardCategory(data[i]);//Auto Add to LoyaltyCardCategoryData

                    if (successFunction!== undefined && treeLoaded)
                        successFunction(LoyaltyCardCategoryData.categoryRoot);
                    deletedLoaded = true;
                },
                function (data) {   //failure
                    $log.error("LoyaltyCardCategory_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined && treeLoaded)
                        errorFunction(data);
                    deletedLoaded = true;

                }
            );
        };
        categorySrv.save = function(category,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
        };
        categorySrv.saveSync = function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var LoyaltyCardCategoryRes = category.getObjectResource();
            LoyaltyCardCategoryRes.$save({}, //no params
                function (data) {

                    try {
                        category.setId(data.id);
                        //TODO  UserActionData.add(data.userAction);
                        if (successFunction) {
                            successFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.remove =  function(category,successFunction,errorFunction)
        {
            LoyaltyCardCategoryData.remove(category);
            ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
        };
        categorySrv.removeSync =  function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var categoryRes = new LoyaltyCardCategory_Resource()
            categoryRes.$remove({id:category.getId()}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.restore =  function(category,successFunction,errorFunction)
        {
            LoyaltyCardCategoryData.restore(category);
            ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
        };
        categorySrv.restoreSync =  function(category,successFunction,errorFunction)
        {
            //$timeout (function () {

            var categoryRes = category.getObjectResource();
            categoryRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        categorySrv.getLoyaltyCardCategoryOnServer =  function(scope,targetName,categoryId)
        {

            var category = null
            if (LoyaltyCardCategoryData.categoryRoot.categories!=null && LoyaltyCardCategoryData.categoryRoot.categories.length>0)
            {
                for (var i=0;i<LoyaltyCardCategoryData.categoryRoot.categories.length && !category;i++)
                    if (LoyaltyCardCategoryData.categoryRoot.categories[i].getId()==categoryId)
                        category = LoyaltyCardCategoryData.categoryRoot.categories[i];
                    else
                        for (var j=0;j<LoyaltyCardCategoryData.categoryRoot.categories[i].categories.length && !category;j++)
                            if (LoyaltyCardCategoryData.categoryRoot.categories[i].categories[j].getId()==categoryId)
                                category = LoyaltyCardCategoryData.categoryRoot.categories[i].categories[j];

                scope[targetName] =  category;
            }
            else
            {

                LoyaltyCardCategory_Resource.get(
                    {id:categoryId},
                    function (categoryRes) {   //success
                        var bookingLoyaltyCards = [];
                        scope[targetName] = new LoyaltyCardCategory(categoryRes);
                    },
                    function (categoryRes) {   //failure
                        //error handling goes here
                    });
            }
        };
        categorySrv.get =  function(categoryId)
        {
            //TODO
            return null;
        };
        categorySrv.getLoyaltyCardById =  function(loyaltyCardId)
        {
            if (LoyaltyCardCategoryData.categoryRoot!=null)
            return LoyaltyCardCategoryData.categoryRoot.getLoyaltyCard(loyaltyCardId);
        };
        categorySrv.loadRef =  function()
        {
            var categories = LoyaltyCardCategoryData.indexCategories;
            for (var i=0;i<categories.length;i++)
                categories[i].loadRef();

        };
        categorySrv.moveLoyaltyCard = function(category,loyaltyCard)
        {
            if (category)
            {
                category.moveLoyaltyCard(loyaltyCard);
                LoyaltyCardSrv.save(loyaltyCard);

            }
        };
        categorySrv.updateLocally =  function(id,object)
        {
            var category = null;
            var parentCategory = null;
            if (object.parentCategoryId)//Optimization : get parent if exist
            {
                parentCategory = LoyaltyCardCategoryData.getById(object.parentCategoryId);
                if  (parentCategory!=null)
                    category = parentCategory.getLoyaltyCardCategoryById(id);
            }
            else
                category = LoyaltyCardCategoryData.getById(id);
            if (category!=null)
                category.loadObject(object,parentCategory);
        };
        categorySrv.addLocally =  function(id,object)
        {
            //TODO
/*            var category = LoyaltyCardCategoryData.getLoyaltyCardCategory(object.parentCategoryId);
            if (category!=null)
                category.addLoyaltyCard(new LoyaltyCard(object,category));*/

        };
        categorySrv.removeLocally =  function(id,object)
        {
            //TODO
/*            var loyaltyCard =  null;
            var category = LoyaltyCardCategoryData.getLoyaltyCardCategory(object.parentCategoryId);
            if (category!=null)
                loyaltyCard = category.getLoyaltyCard(object.id)
            if (loyaltyCard!=null)
                category.removeLoyaltyCard(loyaltyCard);*/
        };

        return categorySrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardCategoryData',["$log", function ($log)
    {
        var  categoryData = 
        {
            categoryRoot : null,
            indexCategories : [], //Used as Index
            deletedCategories : []
        };
        categoryData.getById =  function(categoryId)
        {
            for (var i=0;i<this.indexCategories.length;i++)
                if (this.indexCategories[i].id==categoryId)
                    return this.indexCategories[i];
            return null;
        }
        categoryData.getByIndex =  function(catIndex)
        {
            if (catIndex>=0 && catIndex<this.indexCategories.length)
                return this.indexCategories[catIndex];
            else
                return null;
        }
        categoryData.getIndexOf =  function(category)
        {
            if (category)
                return this.indexCategories.indexOf(category);
            return -1;
        }
        categoryData.add =  function(category)
        {
            this.indexCategories.push(category);
            if (category.isDeleted)
            {
                var index = this.deletedCategories.indexOf(category)
                if (index==-1)
                    this.deletedCategories.push(category);
            }
            return this.indexCategories.length-1;
        }
        categoryData.remove =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index==-1)
            {
                this.deletedCategories.push(category)
                category.isDeleted=true;
            }

        }
        categoryData.restore =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index!=-1)
            {
                this.deletedCategories.splice(index,1)
                category.isDeleted=false;
            }

        }
        categoryData.clear =  function()
        {
            categoryData.categoryRoot = null;
            categoryData.indexCategories = [];
            categoryData.deletedCategories = [];
        }
        categoryData.loaded =  function()
        {
            return (categoryData.categoryRoot != null);
        }
        categoryData.getDeletedList =  function()
        {
            return categoryData.deletedCategories;
        }

        return categoryData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/LoyaltyCardCategory.js